// @ts-nocheck
import React from 'react';
import { crewApi } from './../../lib/api';
import AutocompleteSelect from './AutocompleteSelect';
export default ({
  filter = {},
  ...selectProps
}) => <AutocompleteSelect fetch={async params => {
  return await crewApi.fetch({
    ...filter,
    ...params
  });
}} refetchParams={{
  filter
}} fetchSingle={crewApi.fetch} notFoundText="Бригады не найдены" placeholder="Выберите бригаду" renderOption={(crew, Option) => <Option key={crew.id} value={crew.id} crew={crew}>
        {crew.name}
      </Option>} {...selectProps} />;
